import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { FileSelectorViewModel, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CarModelManipulationView } from "./carModelManipulation-view";
import { CarBrandSelectorViewModel } from "../carBrandManipulation/carBrandManipulation-viewModel";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { PartNumberSearchViewModel } from "../partNumberManipulation/partNumberManipulation-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";

export class CarModelManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت مدل خودروها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.carModels = ObservableArray.create<carModel>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
        this.fileSelector = new FileSelectorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new CarModelManipulationView();
    }
    public getTypeId(): string {
        return "VM-25CCBEF8-58CE-4A1C-9CE9-E27560EB794B"
    }
    public set carModels(v: ObservableArray<carModel>) { this._carModels = v; } public get carModels(): ObservableArray<carModel> { return this._carModels;} private _carModels: ObservableArray<carModel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarModel',{
                FilteringInformation:filteringInformation
            });
            this.carModels.update(...result.CarModel.map((q,i)=>{
                let r = new carModel(this);
                r.index = i+1;
                r.id = q.Id;
                r.fromYear = q.FromYear;
                r.toYear = q.ToYear;
                r.brandId = q.CarBrandId;
                r.brandName = q.CarBrandName;
                r.name = q.Name;
                r.code = q.Code;
                r.enabled = q.IsEnabled;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestCarModelCreation(){
        let editor = new carModelEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async toggle(id:any){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ToggleEnable',{
                Id:id
            });
            if (result.IsSuccessful == false) {
                throw "new Error";
            }
            if (result.IsEnabled) {
                await this.messageBoxConfirmSuccess('مدل خودرو فعال شد','عملیات موفق');
            } else {
                await this.messageBoxConfirmSuccess('مدل خودرو غیر فعال شد','عملیات موفق');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }

    async updatePartNumber(carModel:carModel){
        let editor = new RelatedPartNumber(this);
        editor.loadPartNumbers(carModel);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async carModelUpdater(carModel:carModel){
        let editor = new carModelEditor(this,new UpdateServerUpdater());
        carModel.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportCarModel',{
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelData, `export_car_models.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ImportCarModel',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                throw 'error';
            }
            await this.messageBoxConfirmSuccess('مدل خودرو با موفقیت بروزسانی شد.','عملیات موفق');
            this.refresh();
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class carModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CarModelManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set fromYear(v: number) { 
        this._fromYear = getAsNumber(v, true); } 
        public get fromYear(): number { return this._fromYear;} private _fromYear: number;
    public set toYear(v: number) { 
        this._toYear = getAsNumber(v, true); } 
        public get toYear(): number { return this._toYear;} private _toYear: number;
    public set brandId(v: string) { this._brandId = v; } public get brandId(): string { return this._brandId;} private _brandId: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName;} private _brandName: string;
    public set enabled(v: boolean) { this._enabled = v; } public get enabled(): boolean { return this._enabled;} private _enabled: boolean;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:CarModelManipulationViewModel;

    clone(parent:CarModelManipulationViewModel):carModel{
        let u = new carModel(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(carModel:carModel){
        carModel.id = this.id;
        carModel.name = this.name;
        carModel.code = this.code;
        carModel.fromYear = this.fromYear;
        carModel.toYear = this.toYear;
        carModel.setBrand(this.getBrandId(), this.brandName);
        carModel.enabled = this.enabled;
    }

    async edit(){
        this._typedParent.carModelUpdater(this);
    }    

    setBrand(id: string, name: string) {
        this.brandId = id;
        this.brandName = name;
    }

    getBrandId() {
        return this.brandId;
    }
    
    async toggle(){
        let result:string; 
        if(this.enabled == true) {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن مدل خودرو');
        } else {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','فعال کردن مدل خودرو');
        }
        if(result=='yes'){
            this._typedParent.toggle(this.id);
        }
    }    

    async updatePartNumber(){
        this._typedParent.updatePartNumber(this);
    }    
}

interface IServerUpdater{
    execute(carModel:carModel):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'مدل خودرو با موفقیت ثبت شد.';
    }
    async execute(carModel: carModel): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateCarModel',{
            Name: carModel.name,
            Code: carModel.code,
            FromYear : carModel.fromYear,
            ToYear : carModel.toYear,
            CarBrandId : carModel.getBrandId()
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'مدل خودرو با موفقیت به روز رسانی شد.';

    }
    async execute(carModel: carModel): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateCarModel',{
            Id:carModel.id,
            Name:carModel.name,
            Code:carModel.code,
            FromYear : carModel.fromYear,
            ToYear : carModel.toYear,
            CarBrandId : carModel.getBrandId()
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class carModelEditor extends carModel implements IPopup{
    public getTypeId(): string {return 'editor';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CarModelManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.carModelSelector = new CarBrandSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set carModelSelector(v: CarBrandSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarBrandSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarBrandSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام مدل خودرو مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد مدل خودرو مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getBrandId())){
            result.push('برند خودرو مشخص نشده است.')
        } 
        if(this.fromYear == undefined || this.fromYear < 1300 || this.fromYear > 2100 || this.toYear == undefined || this.toYear < 1300 || this.toYear > 2100){
            result.push('سال مدل نامعتبر است.')
        }
        return result;
    }

    setBrand(id: string, name: string) {
        this.carModelSelector.selectById(id);
        this.brandId = id;
        this.brandName = name;
    }

    getBrandId() {
        return this.carModelSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت مدل خودرو');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class RelatedPartNumber extends ViewModel implements IPopup{
    public getTypeId(): string {return 'partnumber';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CarModelManipulationViewModel) {
        super(parent);
        this.fileSelector = new FileSelectorViewModel(this);
        this.partNumbers = ObservableArray.create<PartNumber>();
        this.partNumberSelector = new PartNumberSearchViewModel(this);
        this.partNumberSelector.onSelectionChanged = q=>{
            let r = new PartNumber(this);
            r.id = q.id;
            r.code = q.code;
            r.pncName = q.pncName;
            r.isSelected = true;
            this.selectPartNumber(r);
        }
    }
    closePopup(resultCode: string = null) {
    }
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set carModelCode(v: string) { this._carModelCode = v; } public get carModelCode(): string { return this._carModelCode;} private _carModelCode: string;
    public set partNumberSelector(v: PartNumberSearchViewModel) { this._partNumberSelector = v; } public get partNumberSelector(): PartNumberSearchViewModel { return this._partNumberSelector;} private _partNumberSelector: PartNumberSearchViewModel;
    public set partNumbers(v: ObservableArray<PartNumber>) { this._partNumbers = v; } public get partNumbers(): ObservableArray<PartNumber> { return this._partNumbers;} private _partNumbers: ObservableArray<PartNumber>;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        
        return result;
    }

    async selectPartNumber(selectedPartNumber: PartNumber){
        if (this.partNumbers.findIndex(q => q.id == selectedPartNumber.id) < 0) {
            this.partNumbers.push(selectedPartNumber);
        }
    }

    async removePartNumber(selectedPartNumber: PartNumber){
        if (this.partNumbers.findIndex(q => q.id == selectedPartNumber.id) >= 0) {
            this.partNumbers.remove(selectedPartNumber);
        }
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت مدل خودرو');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateCarModelPartNumbers',{
                CarModelId: this.carModelId,
                PartNumberIds : this.partNumbers.map(q => q.id)
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            await this.messageBoxConfirmSuccess('کد کالاها به مدل خودرو متصل شد.','عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async loadPartNumbers(carModel:carModel){
        try {
            this.isLoading = true;
            this.carModelId = carModel.id;
            this.carModelName = carModel.name;
            this.carModelCode = carModel.code;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarModelPartNumbers',{
                CarModelId:carModel.id
            });
            this.partNumbers.update(...result.CarModelPartNumbers.map(q=>{
                let r = new PartNumber(this);
                r.id = q.PartNumberId;
                r.pncName = q.PncName;
                r.code = q.PartNumberCode;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ExportCarModelPartNumbers',{
                CarModelId : this.carModelId
             });
            downloadFile(result.ExcelFile, `export part numbers of car model.xlsx`);
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/ImportCarModelPartNumbers',{
                CarModelId : this.carModelId,
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == false) {
                throw 'error';
            }
            await this.messageBoxConfirmSuccess('کد کالاهای مدل خودرو با موفقیت بروزسانی شد.','عملیات موفق');
            this.closePopup("done");
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    removeAll(){
        this.partNumbers.clear();
    }

    back(){
        this.closePopup();
    }
}

export class PartNumber extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:RelatedPartNumber) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : RelatedPartNumber;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pncName(v: string) { this._pncName = v; } public get pncName(): string { return this._pncName;} private _pncName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
    remove(){
        this._typedParent.removePartNumber(this);
    }
    
}

export class CarModelSelectorViewModel extends SelectorBaseViewModel<carModelForSelector>{
    
    constructor(parentViewModel: ViewModel, carBrandId: string) {
        super(parentViewModel, true);
        this.carBrandId = carBrandId;
    }

    public set carBrandId(v: string) { this._carBrandId = v; } public get carBrandId(): string { return this._carBrandId;} private _carBrandId: string;
    
    protected async loadData(): Promise<carModelForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/AllCarModelsOfCarBrand',{
            CarBrandId : this.carBrandId
        });
        return result.CarModels.map(q=>{
            let result = new carModelForSelector(this);
            result.id = q.Id;
            result.title = `${q.Name} (${q.FromYear}-${q.ToYear})`;
            return result;
        });
    }

}

class carModelForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}